// JWT 토큰 관리 유틸리티
const TOKEN_KEY = 'auth_token';
const USER_KEY = 'user_info';

export const tokenManager = {
  // 토큰 저장
  setToken: (token) => {
    localStorage.setItem(TOKEN_KEY, token);
  },

  // 토큰 가져오기
  getToken: () => {
    return localStorage.getItem(TOKEN_KEY);
  },

  // 토큰 삭제
  removeToken: () => {
    localStorage.removeItem(TOKEN_KEY);
  },

  // 토큰 유효성 검사
  isTokenValid: () => {
    const token = localStorage.getItem(TOKEN_KEY);
    if (!token) return false;

    try {
      // JWT 토큰 디코딩 (페이로드 추출)
      const payload = JSON.parse(atob(token.split('.')[1]));
      const expiry = payload.exp * 1000; // exp는 초 단위이므로 밀리초로 변환
      return Date.now() < expiry;
    } catch (error) {
      return false;
    }
  },

  // 토큰에서 사용자 정보 추출
  getUserFromToken: () => {
    const token = localStorage.getItem(TOKEN_KEY);
    if (!token) return null;

    try {
      const payload = JSON.parse(atob(token.split('.')[1]));
      return {
        id: payload.sub,
        email: payload.email,
        name: payload.name,
        role: payload.role
      };
    } catch (error) {
      return null;
    }
  }
};

export const userManager = {
  // 사용자 정보 저장
  setUser: (user) => {
    localStorage.setItem(USER_KEY, JSON.stringify(user));
  },

  // 사용자 정보 가져오기
  getUser: () => {
    const userStr = localStorage.getItem(USER_KEY);
    return userStr ? JSON.parse(userStr) : null;
  },

  // 사용자 정보 삭제
  removeUser: () => {
    localStorage.removeItem(USER_KEY);
  },

  // 로그아웃 (토큰과 사용자 정보 모두 삭제)
  logout: () => {
    tokenManager.removeToken();
    userManager.removeUser();
  }
};